export const DISTANCE_FROM_ITEM = 32;
export const DISTANCE_FROM_IN_EDITOR_ELEMENT = 10;
export const VERTICAL_MARGIN = 16;
export const TOP_BAR_HEIGHT = 82;

export const calculatePreviewPosition = (
  previewRect: DOMRect,
  itemRect: DOMRect,
  hasDynamicPositioning = false
) => {
  const { scrollY } = window;

  let top =
    scrollY + (itemRect.top + itemRect.height / 2 - previewRect.height / 2);

  if (top < scrollY + TOP_BAR_HEIGHT + VERTICAL_MARGIN) {
    top = scrollY + TOP_BAR_HEIGHT + VERTICAL_MARGIN;
  }
  if (
    top + previewRect.height >
    scrollY + window.innerHeight - VERTICAL_MARGIN
  ) {
    top = scrollY + window.innerHeight - VERTICAL_MARGIN - previewRect.height;
  }

  const left = hasDynamicPositioning
    ? calculateDynamicPreviewPosition(previewRect, itemRect)
    : itemRect.left - previewRect.width - DISTANCE_FROM_ITEM;

  return {
    top,
    left
  };
};

const calculateDynamicPreviewPosition = (
  previewRect: DOMRect,
  itemRect: DOMRect
) => {
  const { screenWidth } = getWindowDimensions();
  const elementXPosition = (itemRect.left + itemRect.right) / 2;

  return elementXPosition < screenWidth / 2
    ? itemRect.right + DISTANCE_FROM_IN_EDITOR_ELEMENT
    : itemRect.left - previewRect.width - DISTANCE_FROM_IN_EDITOR_ELEMENT;
};

const getWindowDimensions = () => {
  const { innerWidth: screenWidth } = window;
  return {
    screenWidth
  };
};
